import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'

const ScanDocumentIcon = (props: SvgIconProps) => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path d="M7 3H4v3H2V1h5zm15 3V1h-5v2h3v3zM7 21H4v-3H2v5h5zm13-3v3h-3v2h5v-5zM17 6H7v12h10zm2 12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2zM15 8H9v2h6zm0 3H9v2h6zm0 3H9v2h6z" />
    </SvgIcon>
)

export default ScanDocumentIcon
